// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3v4ef","list":"BalanceDue_list__Vj68p","listRow":"BalanceDue_listRow__3vXic","total":"BalanceDue_total__3u6eW"};